// src/components/DeviceTable.tsx
import React from "react";
import { SessionDevice } from "../api/contracts/deviceTypes";

type DeviceTableProps = {
  devices: SessionDevice[];
  onSelectDevice?: (deviceId: number) => void;
  onEditDevice?: (device: SessionDevice) => void;
};

export const DeviceTable: React.FC<DeviceTableProps> = ({
  devices,
  onSelectDevice,
  onEditDevice,
}) => {
  if (devices.length === 0) {
    return <div className="text-gray-500">No devices registered yet.</div>;
  }

  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-gray-50 text-gray-600 uppercase text-xs">
          <tr>
            <th className="px-4 py-3 text-center">Actions</th>
            <th className="px-4 py-3 text-left">Name</th>
            <th className="px-4 py-3 text-center">Capacity (L)</th>
            <th className="px-4 py-3 text-center">Due Times</th>
            <th className="px-4 py-3 text-center">Relay</th>
          </tr>
        </thead>

        <tbody className="divide-y">
          {devices.map((d) => (
            <tr
              key={d.deviceId}
              className="hover:bg-gray-50 transition"
            >
              <td className="px-4 py-3 text-center">
                <button
                  onClick={() => onEditDevice?.(d)}
                  className="text-blue-600 hover:underline"
                >
                  Edit
                </button>
              </td>

              <td
                className="px-4 py-3 text-blue-600 cursor-pointer hover:underline"
                onClick={() => onSelectDevice?.(d.deviceId)}
              >
                {d.deviceName}
              </td>

              <td className="px-4 py-3 text-center text-gray-700">
                {d.capacityLiters}
              </td>

              <td className="px-4 py-3 text-center text-gray-700">
                {(d.dueTimesLocal ?? []).map(t => t.slice(0, 5)).join(", ")}
              </td>

              <td className="px-4 py-3 text-center">
                <span
                  className={`inline-flex items-center px-2 py-1 rounded text-xs font-medium
                    ${d.relayState
                      ? "bg-green-200 text-green-800"
                      : "bg-gray-200 text-gray-600"
                    }`}
                >
                  {d.relayState ? "ON" : "OFF"}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
